import GoalsIcon from './component.jsx'
export default GoalsIcon
